import React, { useState, useCallback, useEffect } from "react";
import { Icon, message, Row, Col, Button, Input, Divider, Radio } from "antd";
import moment from "moment";
import { figurenames, figures, webEntity } from "../../constants";

// Styles
import { Wrapper, Block, HeaderOptions, ThreeBox } from "./styles";

// Components
import Carousel from "../../components/carousel";
import Select from "../../components/select";
import Slider from "../../components/slider";
import ThreeFigure from "../../components/three-figure";

// Hooks
import useArticles from "../../hooks/useArticles";

import { grades } from "../../constants";

//import multilanguage library
import { useTranslation } from "react-i18next";

const SelectOptions = [
  {
    key: 0,
    name: "prototipo",
    value: "prototype",
  },
  {
    key: 1,
    name: "catálogo",
    value: "catalogue",
  },
];

const slidersKeys = {
  hard_coat: "hard_coat",
  hardness_required: "hardness_required",
};

const desingDefaultValues = {
  name: "",
  is_prototype: false,
  grade: 1,
  figure: figures["cylinder"],
  selected_figure: "cylinder",
  hard_coat: 20,
  hardness_required: 700,
};

const Articulo = ({ desing, back = false, close, changeTitle, editOrClone, addNewRowOnClone }) => {
  const [state, setState] = useState(desing);
  const [articlesType, setArticlesType] = useState(null);

  //To translate text
  const { t } = useTranslation();

  const { setArticle, articleTypes, getOneArticle, updateArticle } = useArticles();

  useEffect(() => {
    changeTitle && changeTitle("new_article");
  }, [changeTitle]);

  //Det figures from database
  useEffect(() => {
    async function fetchData() {
      const response = await articleTypes();
      if (response) {
        let objFigures = {};
        response.forEach((el) => {
          objFigures[el.name.toLowerCase()] = el.id_article_type;
        });
        setArticlesType(objFigures);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (editOrClone) {
      async function getArt(id) {
        const art = await getOneArticle(id);
        art.name = editOrClone.type === "clone" ? "" : art.name;
        setState(art);
      }
      getArt(editOrClone.id);
    } else {
      setState(desingDefaultValues);
    }
  }, [editOrClone]);

  // Current figure
  const figureData = state && state.selected_figure && figurenames[state.selected_figure];

  const handleChangueGrade = ({ value }) => setState({ ...state, grade: value });

  const handleChangePrototype = (prototype) => {
    const { value } = prototype.target;
    const { value: prototypeValue } = SelectOptions.find((el) => el.key === value);

    let is_prototype = false;
    if (prototypeValue === "prototype") is_prototype = true;
    if (prototypeValue === "catalogo") is_prototype = false;

    setState({ ...state, is_prototype });
  };

  const handleSaveArticle = (e) => {
    e.preventDefault();
    isActive() && saveData();
    //back && close();
  };

  // find in article -> figures they attributes by selected figure
  const RenderFigureSlider = useCallback(
    ({ name, min, max, figureKey, unit }) => {
      const figure = state.figure && state.figure.values;
      const [_, value] = figure && Object.entries(figure).find(([figKey]) => figKey === figureKey);

      const callback = (value) => {
        setState((prevState) => {
          return {
            ...prevState,
            figure: {
              name: prevState.figure.name,
              values: { ...prevState.figure.values, [figureKey]: value },
            },
          };
        });
        // updateFigureValue(figureObj);
      };

      return slider({ name, min, max, value, callback, unit });
    },
    [state && state.selected_figure]
  );

  // Find in article the incomming key
  const RenderSlider = useCallback(
    ({ name, min, max, unit, findKey }) => {
      const value = state && state[findKey];
      const callback = (v) => {
        if (findKey === slidersKeys.hard_coat) setState((prevState) => ({ ...prevState, hard_coat: v }));

        if (findKey === slidersKeys.hardness_required) setState((prevState) => ({ ...prevState, hardness_required: v }));
      };

      return slider({ name, min, max, unit, value, callback });
    },
    [state && state.name]
  );

  const slider = ({ name, min, max, value, unit, callback }) => {
    return <Slider name={name} min={min} max={max} unit={unit} value={value} callback={callback} />;
  };

  const getMin2slider = (name) => {
    return name === "radius"
      ? 50
      : name === "height"
      ? 100
      : name === "tube"
      ? 70
      : name === "width"
      ? 100
      : name === "length"
      ? 100
      : name === "depth"
      ? 100
      : name === "angle"
      ? 0
      : 0;
  };

  const getMax2slider = (name) => {
    return name === "radius"
      ? 750
      : name === "height"
      ? 4000
      : name === "tube"
      ? 350
      : name === "width"
      ? 4000
      : name === "length"
      ? 4000
      : name === "depth"
      ? 4000
      : name === "angle"
      ? 90
      : 0;
  };

  const handleChangueArticleName = (e) => {
    setState({ ...state, name: e.target.value });
  };

  const isActive = () => {
    return state && state.name.length > 0;
  };

  const saveData = () => {
    if (editOrClone && editOrClone.type === "edit") {
      ///Realizar los cambios tras actualizar

      const update_article = {
        id_article: state.id_article,
        name: state.name,
        is_prototype: state.is_prototype,
        id_article_type: state.id_article_type, //Si no, cilindro
        grade: state.grade,
        properties: [
          { tag: "grade", value: state.grade.toString() },
          { tag: "hard_coat", value: state.hard_coat.toString() },
          { tag: "hardness_required", value: state.hardness_required.toString() },
        ],
      };

      Object.entries(state.figure.values).forEach((obj) => {
        update_article.properties.push({ tag: obj[0], value: obj[1].toString() });
      });

      async function udtArticle(art) {
        const response = await updateArticle(art);
        if (response) {
          message.success(t("alerts.data_updated"));
          addNewRowOnClone(art, "update");
          back && close();
        } else {
          message.error(t("alerts.article_not_added"));
        }
      }

      udtArticle(update_article);
    } else {
      const new_article = {
        name: state.name,
        is_prototype: state.is_prototype,
        date: moment().format(),
        id_article_type: articlesType && articlesType[state.selected_figure] ? articlesType[state.selected_figure] : 1, //Si no, cilindro
        properties: [
          { tag: "grade", value: state.grade.toString() },
          { tag: "hard_coat", value: state.hard_coat.toString() },
          { tag: "hardness_required", value: state.hardness_required.toString() },
        ],
      };

      Object.entries(state.figure.values).forEach((obj) => {
        new_article.properties.push({ tag: obj[0], value: obj[1].toString() });
      });

      async function createNewArticle(art) {
        const response = await setArticle(art, webEntity);
        if (response) {
          message.success(t("alerts.article_added"));

          if (editOrClone && editOrClone.type === "clone") {
            art.id_article = response;
            let id_article_type_obj = { name: "cylinder" };
            articlesType &&
              Object.keys(articlesType).forEach((el, i) => {
                if (articlesType[el] === art.id_article_type) id_article_type_obj.name = el;
              });
            art.id_article_type = id_article_type_obj;
            addNewRowOnClone(art, "clone");
            back && close();
          } else {
            setState({
              ...state,
              name: "",
            });
          }
          /*setState({
            ...state,
            name: "",
          });*/
        } else {
          message.error(t("alerts.article_not_added"));
        }
      }
      createNewArticle(new_article);
    }
  };

  const onChangeSelectedFigure = (selected_figure) => {
    setState({
      ...state,
      selected_figure,
      figure: figures[selected_figure],
    });
  };

  const radioStyle = {
    display: "block",
    width: "100%",
    borderRadius: "4px",
    marginBottom: "10px",
    textAlign: "center",
  };

  return (
    <Wrapper>
      <Row style={{ margin: 0 }} gutter={[16, 16]}>
        <Col xl={24} lg={24}>
          <Row style={{ marginBottom: 20 }} gutter={[16, 16]} type="flex" justify="space-between">
            <Col>
              <Input
                prefix={<Icon type="profile" style={{ color: "rgba(0,0,0,.25)" }} />}
                value={state ? state.name : ""}
                placeholder={t("placeholder.no_title")}
                onChange={handleChangueArticleName}
              />
            </Col>
            <Col>
              {back && (
                <Button onClick={() => close()}>
                  <Icon type="close" />
                  {t("button.cancel")}
                </Button>
              )}
              {back && <Divider type="vertical"></Divider>}
              <Button type="primary" disabled={!isActive()} onClick={(e) => handleSaveArticle(e)}>
                <Icon type="save" />
                {state && state.type ? t("button.update") : t("button.save")}
              </Button>
            </Col>
          </Row>
          <Row style={{ margin: 0 }} gutter={[16, 16]}>
            {state && (
              <Col lg={8} md={24}>
                <Col span={24}>
                  <HeaderOptions style={{ marginBottom: "20px" }}>{t("headers.article.figure_type")}</HeaderOptions>
                  <Carousel defaultValue={state.selected_figure} onChange={onChangeSelectedFigure} />
                  <Block style={{ marginTop: "20px" }}>
                    <Select values={SelectOptions} defaultValue={state.is_prototype ? 0 : 1} callback={handleChangePrototype} />
                  </Block>
                </Col>

                <Col span={24}>
                  <ThreeBox>
                    <ThreeFigure figureData={state.figure} />
                  </ThreeBox>
                </Col>
              </Col>
            )}
            <Col lg={8} md={24}>
              <Col span={24} style={{ minHeight: "250px" }}>
                <HeaderOptions>{t("headers.article.piece_geometry")}</HeaderOptions>
                {figureData &&
                  figureData.map((figure) => {
                    return (
                      <Col key={figure.key} span={24}>
                        <RenderFigureSlider
                          key={figure.key}
                          figureKey={figure.key}
                          name={t("labels.measurements." + figure.key)}
                          min={getMin2slider(figure.key)}
                          max={getMax2slider(figure.key)}
                          unit="mm"
                        />
                      </Col>
                    );
                  })}
              </Col>
            </Col>
            <Col lg={8} md={24}>
              <Col span={24}>
                <HeaderOptions>{t("headers.article.piece_properties")}</HeaderOptions>
                <Col span={24}>
                  <RenderSlider findKey={slidersKeys.hard_coat} name={t("labels.hard_coat")} min={10} max={50} unit="mm" />
                </Col>
                <Col span={24}>
                  <RenderSlider
                    findKey={slidersKeys.hardness_required}
                    name={t("labels.hardness_required")}
                    min={500}
                    max={1000}
                    unit="HV1"
                  />
                </Col>
              </Col>
              <Col span={24}>
                <HeaderOptions>{t("headers.article.steel_grade")}</HeaderOptions>
                {/*<Col span={24}>
                <List data={grades} selectedKey={grades.find(grade => grade.value === state.grade).key} callback={handleChangueGrade} />
              </Col>*/}
                <Col span={24}>
                  {grades && state && (
                    <Radio.Group
                      value={grades.find((grade) => grade.value === state.grade).value}
                      onChange={(el) => handleChangueGrade({ value: el.target && el.target.value })}
                      size="large"
                      style={{ width: "100%" }}
                    >
                      {grades.map((obj) => (
                        <Radio.Button style={radioStyle} key={obj.key} value={obj.value}>
                          {obj.name}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                  )}
                </Col>
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
};
export default Articulo;
